<template>
  <div
    v-if="widget && mode !== 'hidden'"
    class="hbt"
  >
    <div class="hbt-coach-box">
      <div class="hbt-coach-body">
        <div
          class="d-flex align-items-center mb-50"
          style="gap: 10px;"
        >
          <span class="hbt-kicker">{{ widget.param.title || 'ИИ-тренер' }} / {{ widget.param.subtitle || 'AI coach' }}</span>
          <span class="hbt-coach-badge">{{ badge }}</span>
        </div>
        <div
          class="hbt-h3"
          style="font-size: 19px;"
        >{{ coachTitle }}</div>
        <p class="hbt-coach-text">
          {{ widget.param.coachbody || '' }}
        </p>
      </div>
      <div
        v-if="widget.param.showactions"
        class="d-flex flex-wrap"
        style="gap: 8px;"
      >
        <button
          type="button"
          class="hbt-btn hbt-btn-acc"
        >Принять план</button>
        <button
          type="button"
          class="hbt-btn"
        >Открыть тренера</button>
      </div>
    </div>
  </div>
</template>

<script>
import { hbtLoadHabits } from '@/cubus/components/dashboard/habits/habitsCore'

export default {
  name: 'CbsWidgetHabitCoach',
  props: {
    widget: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      habits: [],
    }
  },
  computed: {
    mode() {
      return this.widget.param.mode || 'preview'
    },
    badge() {
      if (this.widget.param.badge) return this.widget.param.badge
      return this.mode === 'active' ? 'включён' : 'скоро'
    },
    coachTitle() {
      const base = this.widget.param.coachtitle || 'План на сегодня'
      const counts = this.habits.filter(h => h.type === 'count' && h.plan > 0)
      if (!counts.length) return base
      const parts = counts.map(h => `${h.plan} ${this.genitive(h)}`)
      return `${base}: ${parts.join(', ')}`
    },
  },
  created() {
    this.load()
  },
  methods: {
    async load() {
      this.habits = await hbtLoadHabits(this, this.widget.param)
    },
    // «100 отжиманий» из названия привычки «Отжимания»
    genitive(habit) {
      const n = (habit.name || '').toLowerCase()
      if (n.endsWith('ия')) return `${n.slice(0, -1)}й`
      if (n.endsWith('а')) return `${n.slice(0, -1)}и`
      return n
    },
  },
}
</script>

<style src="./habits/habits.css"></style>
<style scoped>
.hbt-coach-box {
  border: 2px solid rgba(32, 30, 29, 0.4);
  padding: 16px;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  align-items: flex-start;
}
.hbt-coach-body {
  flex: 1;
  min-width: 260px;
}
.hbt-coach-badge {
  font-size: 10px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  background: #eae9e9;
  color: rgba(32, 30, 29, 0.7);
  padding: 3px 8px;
}
.hbt-coach-text {
  margin: 6px 0 0;
  font-size: 14px;
  color: rgba(32, 30, 29, 0.75);
  max-width: 62ch;
}
</style>
